export const APP_ICON = {
  "Icon.Space.Around": {
    defaultValue: "default"
  },
  "Icon.Space.Around.Top": {
    defaultValue: "2px"
  },
  "Icon.Space.Around.Right": {
    defaultValue: "2px"
  },
  "Icon.Space.Around.Bottom": {
    defaultValue: "2px"
  },
  "Icon.Space.Around.Left": {
    defaultValue: "2px"
  },

  "Icon.Height.Type": {
    defaultValue: "fixed"
  },

  "Icon.Size.Type": {
    defaultValue: "auto"
  },
  "Icon.Size": {
    defaultValue: "12px"
  },
  "Icon.Justify.Content": {
    defaultValue: "center"
  },
  "Icon.Align.Items": {
    defaultValue: "center"
  },

  "Icon.Color": {
    ref: "Color.Gray.600"
  },
  "Icon.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Icon.Hover.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Icon.Badge.Color": {
    ref: "Color.Secondary.Four.500"
  },
  "Icon.Border.Color": {
    ref: "Color.Black"
  },
  "Icon.Hover.Border.Color": {
    ref: "Color.Black"
  },
  "Icon.Border.Style": {
    defaultValue: "solid"
  },
  "Icon.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Icon.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Icon.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Icon.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Icon.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Icon.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Icon.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Icon.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Icon.Margin.Top": {
    defaultValue: "0px"
  },
  "Icon.Margin.Right": {
    defaultValue: "0px"
  },
  "Icon.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Icon.Margin.Left": {
    defaultValue: "0px"
  },
  "Icon.Padding.Top": {
    defaultValue: "0px"
  },
  "Icon.Padding.Right": {
    defaultValue: "0px"
  },
  "Icon.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Icon.Padding.Left": {
    defaultValue: "0px"
  },
  "Icon.Width": {
    defaultValue: "24px"
  },
  "Icon.Height": {
    defaultValue: "24px"
  },
  "Icon.Min.Height": {
    defaultValue: "unset"
  },
  "Icon.Min.Width": {
    defaultValue: "unset"
  },
  "Icon.Max.Height": {
    defaultValue: "unset"
  },
  "Icon.Max.Width": {
    defaultValue: "unset"
  },
  "Icon.Shadow.Type": {
    defaultValue: "none"
  },
  "Icon.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Icon.Cursor": {
    defaultValue: "pointer"
  },
  "Icon.Hover.Shadow.Type": {
    defaultValue: "none"
  },
  "Icon.Hover.Shadow.Color": {
    ref: "Color.Shadow"
  },
  "Icon.Box.Sizing": {
    defaultValue: "border-box"
  }
};
